import {
    GET_ALL_ITEM_CATEGORY,
    GET_ALL_ITEM_STYLES,
    GET_ONE_ITEM_CATEGORY,
    GET_ONE_ITEM_STYLE,
} from '../types'

const initialState = {
    itemCategories: null,
    itemCategory: null,
    itemStyle: null,
    itemStyles: null,
}

const itemCategoryReducer = (state = initialState, action) => {
    const { type, payload } = action
    switch (type) {
        case GET_ALL_ITEM_CATEGORY:
            return {
                ...state,
                itemCategories: payload,
                itemCategory: null,
                itemStyle: null,
            }
        case GET_ONE_ITEM_CATEGORY:
            return {
                ...state,
                itemCategory: payload,
            }
        case GET_ONE_ITEM_STYLE:
            return {
                ...state,
                itemStyle: payload,
            }
        case GET_ALL_ITEM_STYLES:
            return {
                ...state,
                itemStyles: payload,
            }
        default:
            return state
    }
}

export default itemCategoryReducer
